import React from 'react';

interface ITitleProps {
	size?: string;
}

export const Title = ({ size = '24' }: ITitleProps) => {
	return (
		<svg
			aria-hidden="true"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			className="inline align-middle">
			<path
				d="M4.00562 21.9999C3.96571 20.9726 4.13866 19.948 4.51361 18.9907C4.88855 18.0333 5.4574 17.1638 6.18442 16.4368C6.91144 15.7098 7.78092 15.1409 8.73828 14.766C9.69563 14.391 10.7202 14.2181 11.7476 14.258C12.7749 14.2181 13.7995 14.391 14.7568 14.766C15.7142 15.1409 16.5837 15.7098 17.3107 16.4368C18.0377 17.1638 18.6066 18.0333 18.9815 18.9907C19.3565 19.948 19.5294 20.9726 19.4895 21.9999H4.00562Z"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.7472 12.3226C14.5977 12.3226 16.9085 10.0118 16.9085 7.16129C16.9085 4.31079 14.5977 2 11.7472 2C8.89673 2 6.58594 4.31079 6.58594 7.16129C6.58594 10.0118 8.89673 12.3226 11.7472 12.3226Z"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.909 6.30958C15.9861 6.88799 14.9141 7.184 13.8252 7.1612C12.6177 7.16423 11.4344 6.82212 10.4149 6.17518C9.39529 5.52823 8.58184 4.60339 8.07031 3.50958"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
